import { Box, TextButton } from '@zillow/constellation-10';
import { useFieldArray } from 'react-hook-form';
import { MAX_VEHICLES } from '../../../../constants/form';
import { EMPTY_VEHICLE } from '../../../../utils/application-edit';
import { VEHICLES_FIELD_ARRAY_NAME, VehicleEdit } from './VehicleEdit';

export function VehiclesList() {
  const { fields, append, remove } = useFieldArray({ name: VEHICLES_FIELD_ARRAY_NAME });

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', marginTop: 'default' }}>
      {fields.map((vehicle, index) => (
        <VehicleEdit key={vehicle.id} index={index} onDelete={() => remove(index)} />
      ))}
      {fields.length < MAX_VEHICLES && (
        <TextButton type="button" onClick={() => append(EMPTY_VEHICLE)} css={{ alignSelf: 'center' }}>
          Add vehicle
        </TextButton>
      )}
    </Box>
  );
}
